export const SET_MANAGER_FILTER = 'SET_MANAGER_FILTER';
